import React, { useEffect, useMemo, useState } from "react";
import { Label, FormFeedback, FormGroup, FormText } from "reactstrap";
import Select from "react-select/async";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";
import { getLTAs } from "common/services/ltas.service";
import { normalize } from "common/lib/normalize";

const FIELD = "lta";

const toOption = (lta: any) => ({
  value: lta?.id,
  label: lta?.ltaNumber ? `${lta.title} (${lta.ltaNumber})` : lta?.title,
});

/**
 * Links a contract to the Long Term Agreement it was awarded under.
 *
 * Optional — most contracts stand alone. Searchable by title or LTA number
 * because agencies refer to agreements by both.
 */
const SelectLTA = ({ validation }: { validation: any }) => {
  const invalid = validation.touched[FIELD] && validation.errors[FIELD];

  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: invalid ? "red" : "#ced4da",
      "&:hover": { borderColor: invalid ? "red" : "#ced4da" },
    }),
  };

  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: any = await getLTAs({
          pagination: { page: 1, pageSize: 20 },
          sort: "title:asc",
          populate: [],
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(() => data.map(toOption), [data]);

  return (
    <FormGroup>
      <Label htmlFor="lta-field" className="form-label">
        Is this Contract part of an LTA?
      </Label>
      <Select
        name={FIELD}
        id={FIELD}
        value={validation.values[FIELD]?.value ? validation.values[FIELD] : null}
        isClearable
        placeholder="Search by LTA title or number"
        onChange={(value: any) => {
          validation.setFieldValue(FIELD, value || { value: "", label: "" });
          validation.setFieldError(FIELD, "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) =>
          getLTAs({
            pagination: { page: 1, pageSize: 20 },
            populate: [],
            filters: {
              $or: [
                { title: { $containsi: inputValue } },
                { ltaNumber: { $containsi: inputValue } },
              ],
            },
          }).then((result: any) => {
            callback(normalize(result.data).map(toOption));
          })
        }
        onBlur={() => validation.setFieldTouched(FIELD, true)}
        className={invalid ? "is-invalid" : ""}
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormText>
        Leave blank if this contract was not awarded under an LTA.
      </FormText>
      <FormFeedback>{validation.errors[FIELD]?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectLTA;
